import React, { Fragment } from "react";
import { connect } from "react-redux";
import moment from "moment";
import MomentUtils from "@date-io/moment";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import Toolbar from "@material-ui/core/Toolbar";
import Tooltip from "@material-ui/core/Tooltip";
import { getDeliveries } from "../actions/deliveriesAction";
import Deliveries from "../components/logistics/Deliveries";
import CreateRouteMap from "../components/logistics/CreateRouteMap";
import Routes from "../components/logistics/DriverRoutes";
import DeliveryInstructions from "../components/logistics/DeliveryInstructions";
import Spinner from "../components/layout/Spinner";

class DeliveriesContainer extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    console.log(this.props);
    this.props.getDeliveries(this.props.selectedDate);
  }

  updateDeliveries = () => {
    this.props.getDeliveries(this.props.selectedDate);
  };

  handleDateChange = (date) => {
    this.props.setSelectedDate(moment(date).format("YYYY-MM-DD"));
    console.log(moment(date).format("YYYY-MM-DD"));
    this.props.getDeliveries(moment(date).format("YYYY-MM-DD"));
  };

  render() {
    const { loading, deliveries } = this.props.deliveries;
    return (
      <Fragment>
        <Toolbar>
          <Tooltip title="Choose date">
            <MuiPickersUtilsProvider utils={MomentUtils}>
              <KeyboardDatePicker
                margin="normal"
                variant="dialog"
                autoOk
                showTodayButton
                disableToolbar
                inputVariant="outlined"
                id="date-picker-dialog"
                // label="Choose Date"
                format="dddd, MMM DD"
                value={this.props.selectedDate}
                onChange={this.handleDateChange}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
              />
            </MuiPickersUtilsProvider>
          </Tooltip>
        </Toolbar>
        {loading ? (
          <Spinner />
        ) : (
          <Fragment>
            {this.props.tab === "deliveries" && (
              <Deliveries
                deliveries={deliveries.deliveries}
                drivers={deliveries.drivers}
                routes={deliveries.routes}
                updateDeliveries={this.updateDeliveries}
              />
            )}
            {this.props.tab === "instructions" && (
              <DeliveryInstructions
                deliveries={deliveries.deliveries}
                drivers={deliveries.drivers}
                routes={deliveries.routes}
              />
            )}
            {this.props.tab === "routes" && (
              <Routes
                deliveries={deliveries.deliveries}
                drivers={deliveries.drivers}
                routes={deliveries.routes}
                timeslots={deliveries.bookings}
              />
            )}
            {this.props.tab === "create_routes" && (
              <CreateRouteMap
                deliveries={deliveries.deliveries}
                bookings={deliveries.bookings}
                drivers={deliveries.drivers}
                routes={deliveries.routes}
              />
            )}
          </Fragment>
        )}
      </Fragment>
    );
  }
}
const mapStateToProps = ({ deliveries }) => ({
  deliveries: deliveries,
});
const mapDispatchToProps = (dispatch) => ({
  getDeliveries: (deliveries) => dispatch(getDeliveries(deliveries)),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeliveriesContainer);
